import React from 'react';
import { Controller } from 'react-hook-form';
import FormControl from 'presentation/components/FormControl';
import { FormValidator } from 'tools/FormValidator';
import { useTranslation } from 'react-i18next';
import Input from 'presentation/components/Input';

interface HouseNumberFieldProps {
  formControl: any;
  errors: any;
  setValue: (name: 'street' | 'houseNr' | 'zip' | 'city', value: any) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const HouseNumberField: React.FC<HouseNumberFieldProps> = ({ formControl, errors, inputRef }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'page.houseAddress'
  });

  return (
    <FormControl
      required
      additionalTestId="house-number"
      label={<span id="housenr-label">{t('labelHouseNumber')}</span>}
      error={errors.houseNr && t('errorHouseNumber')}
      htmlFor="field-housenr"
    >
      <Controller
        name="houseNr"
        control={formControl}
        rules={{
          required: true,
          validate: {
            validate: (v) => FormValidator.isValidHouseNumber(v)
          }
        }}
        render={({ field }) => (
          <Input
            id="field-housenr"
            type="text"
            aria-labelledby="housenr-label"
            aria-required="true"
            aria-invalid={!!errors.houseNr}
            aria-describedby={errors.houseNr ? 'houseNr-error' : undefined}
            inputRef={inputRef}
            autoComplete="address-line2"
            {...field}
          />
        )}
      />
    </FormControl>
  );
};

export default HouseNumberField;
